module.exports = __webpack_public_path__ + "static/media/hadi-partovi.48449bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/hadi-partovi.png
// module id = 242
// module chunks = 0